import { Routes } from '@angular/router';
import { LoginComponent } from './features/auth/login/login.component';
import { NotFoundComponent } from './features/not-found/not-found.component';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: 'auth/login',
    component: LoginComponent,
    title: 'Inicio de sesión',
  },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadComponent: () =>
      import('@dashboard/dashboard.component').then(
        (c) => c.DashboardComponent,
      ),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('@home/home.component').then((c) => c.HomeComponent),
      },
      {
        path: 'perfil',
        loadComponent: () =>
          import('@perfil/perfil.component').then((c) => c.PerfilComponent),
        title: 'Perfil',
      },
      {
        path: 'users',
        loadComponent: () =>
          import('@usuarios/users.component').then((c) => c.UsersComponent),
        children: [
          {
            path: '',
            redirectTo: 'list',
            pathMatch: 'full',
          },
          {
            path: 'list',
            loadComponent: () =>
              import('@usuarios/user-list/user-list.component').then(
                (c) => c.UserListComponent,
              ),
            title: 'Usuarios',
          },
          {
            path: 'form',
            loadComponent: () =>
              import('@usuarios/user-form/user-form.component').then(
                (c) => c.UserFormComponent,
              ),
            title: 'Formulario usuario',
          },
          {
            path: 'edit/:id',
            loadComponent: () =>
              import('@usuarios/user-edit/user-edit.component').then(
                (c) => c.UserEditComponent,
              ),
            title: 'Editar usuario',
          },
          {
            path: 'details/:id',
            loadComponent: () =>
              import('@usuarios/user-details/user-details.component').then(
                (c) => c.UserDetailsComponent,
              ),
            title: 'Detalles de usuario',
          },
        ],
      },
      {
        path: 'country',
        loadComponent: () =>
          import('@regiones/regiones.component').then(
            (c) => c.RegionesComponent,
          ),
        children: [
          {
            path: '',
            redirectTo: 'list',
            pathMatch: 'full',
          },
          {
            path: 'list',
            loadComponent: () =>
              import('@regiones/lista-de-pais/lista-de-pais.component').then(
                (c) => c.ListaDePaisComponent,
              ),
            title: 'Países',
          },
          {
            path: 'details/:id',
            loadComponent: () =>
              import('@regiones/detalles-de-pais/detalles-de-pais.component').then(
                (c) => c.DetallesDePaisComponent,
              ),
            title: 'Detalles de país',
          },
          {
            path: ':id/state-details/:id-state',
            loadComponent: () =>
              import('@regiones/estado/detalles-de-estado/detalles-de-estado.component').then(
                (c) => c.DetallesDeEstadoComponent,
              ),
            title: 'Detalles del Estado',
          },
        ],
      },
      {
        path: 'company',
        loadComponent: () =>
          import('@empresas/empresas.component').then(
            (c) => c.EmpresasComponent,
          ),
        children: [
          {
            path: '',
            redirectTo: 'list',
            pathMatch: 'full',
          },
          {
            path: 'list',
            loadComponent: () =>
              import('@empresas/lista-de-empresa/lista-de-empresa.component').then(
                (c) => c.ListaDeEmpresaComponent,
              ),
            title: 'Empresas',
          },
          {
            path: 'edit/:id',
            loadComponent: () =>
              import('@empresas/formulario-de-empresa/formulario-de-empresa.component').then(
                (c) => c.FormularioDeEmpresaComponent,
              ),
            title: 'Editar empresa',
          },
          {
            path: 'form',
            loadComponent: () =>
              import('@empresas/formulario-de-empresa/formulario-de-empresa.component').then(
                (c) => c.FormularioDeEmpresaComponent,
              ),
            title: 'Registrar empresa',
          },
          {
            path: 'modules/:id',
            loadComponent: () =>
              import('@empresas/modulos-de-empresa/modulos-de-empresa.component').then(
                (c) => c.ModulosDeEmpresaComponent,
              ),
            title: 'Gestión de empresa',
            children: [
              {
                path: 'details',
                loadComponent: () =>
                  import('@empresas/detalles-de-empresa/detalles-de-empresa.component').then(
                    (c) => c.DetallesDeEmpresaComponent,
                  ),
                title: 'Detalles de la empresa',
              },
              {
                path: 'assistance',
                loadComponent: () =>
                  import('@asistencia/lista-de-asistencia/lista-de-asistencia.component').then(
                    (c) => c.ListaDeAsistenciaComponent,
                  ),
                title: 'Asistencias',
              },
              {
                path: 'sucursal',
                loadComponent: () =>
                  import('@sucursales/lista-de-sucursal/lista-de-sucursal.component').then(
                    (c) => c.ListaDeSucursalComponent,
                  ),
                title: 'Sucursales',
              },
              {
                path: 'user',
                loadComponent: () =>
                  import('@usuarios/user-list/user-list.component').then(
                    (c) => c.UserListComponent,
                  ),
                title: 'Usuarios',
              },
              {
                path: 'crane',
                loadComponent: () =>
                  import('@gruas/lista-de-grua/lista-de-grua.component').then(
                    (c) => c.ListaDeGruaComponent,
                  ),
                title: 'Grúas',
              },
              // {
              //   path:'plan-price',
              //   loadComponent:()=> import('@plan-de-precios/lista-plan-de-precios/lista-plan-de-precios.component').then((c)=>c.ListaPlanDePreciosComponent),
              //   title:'Planes'
              // }
            ],
          },
          // -Empresa/ID de la empresa/sucursal/ID de la sucursal: Interfaz de sucursal que contiene varias vistas y funcionalidades
          {
            path: ':id-empresa/sucursal/:id-sucursal',
            loadComponent: () =>
              import('@sucursales/modulos-de-sucursales/modulos-de-sucursales.component').then(
                (c) => c.ModulosDeSucursalesComponent,
              ),
            children: [
              {
                path: 'details',
                loadComponent: () =>
                  import('@sucursales/detalles-de-sucursal/detalles-de-sucursal.component').then(
                    (c) => c.DetallesDeSucursalComponent,
                  ),
                title: 'Detalles de la sucursal',
              },
              {
                path: 'zone-delimitation',
                loadComponent: () =>
                  import('@zonas/lista-de-zonas/lista-de-zonas.component').then(
                    (c) => c.ListaDeZonasComponent,
                  ),
                title: 'Lista se zonas',
              },
              {
                path: 'assistance',
                loadComponent: () =>
                  import('@asistencia/lista-de-asistencia/lista-de-asistencia.component').then(
                    (c) => c.ListaDeAsistenciaComponent,
                  ),
                title: 'Lista de asistencias',
              },
              {
                path: 'crane',
                loadComponent: () =>
                  import('@gruas/lista-de-grua/lista-de-grua.component').then(
                    (c) => c.ListaDeGruaComponent,
                  ),
                title: 'Grúas de sucursal',
              },
              {
                path: 'plan-price',
                loadComponent: () =>
                  import('@plan-de-precios/lista-plan-de-precios/lista-plan-de-precios.component').then(
                    (c) => c.ListaPlanDePreciosComponent,
                  ),
                title: 'Planes de precio',
              },
            ],
          },
          {
            path: ':id-empresa/user/:id-usuario',
            loadComponent: () =>
              import('@usuarios/user-details/user-details.component').then(
                (c) => c.UserDetailsComponent,
              ),
            title: 'Detalles de usuario',
          },
          {
            path: ':id-empresa/form-user',
            loadComponent: () =>
              import('@usuarios/user-form/user-form.component').then(
                (c) => c.UserFormComponent,
              ),
            title: 'Alta usuario',
          },
          {
            path: ':id-empresa/crane/:id-grua',
            loadComponent: () =>
              import('@gruas/detalles-de-grua/detalles-de-grua.component').then(
                (c) => c.DetallesDeGruaComponent,
              ),
            title: 'Detalles de grúa',
          },
          {
            path: ':id-empresa/form-crane',
            loadComponent: () =>
              import('@gruas/formulario-de-grua/formulario-de-grua.component').then(
                (c) => c.FormularioDeGruaComponent,
              ),
            title: 'Registrar grúa',
          },
          {
            path: ':id-empresa/edit-crane/:id-grua',
            loadComponent: () =>
              import('@gruas/formulario-de-grua/formulario-de-grua.component').then(
                (c) => c.FormularioDeGruaComponent,
              ),
            title: 'Editar grúa',
          },
          {
            path: ':id-empresa/sucursal/:id-sucursal/plan-price/:id-plan-price',
            loadComponent: () =>
              import('@plan-de-precios/gestion-de-productos/gestion-de-productos.component').then(
                (c) => c.GestionDeProductosComponent,
              ),
            title: 'Agregar productos a plan',
          },
          {
            path: ':id-empresa/assistance/:id-asistencia',
            loadComponent: () =>
              import('@asistencia/detalles-de-asistencia/detalles-de-asistencia.component').then(
                (c) => c.DetallesDeAsistenciaComponent,
              ),
            title: 'Detalles de asistencia',
          },
          {
            path: ':id-empresa/form-zone/:id-sucursal',
            loadComponent: () =>
              import('@zonas/formulario-delimitacion-de-zona/formulario-delimitacion-de-zona.component').then(
                (c) => c.FormularioDelimitacionDeZonaComponent,
              ),
            title: 'Registar zona',
          },
          {
            path: ':id-empresa/zone-delimitation/:id-zone',
            loadComponent: () =>
              import('@zonas/formulario-delimitacion-de-zona/formulario-delimitacion-de-zona.component').then(
                (c) => c.FormularioDelimitacionDeZonaComponent,
              ),
            title: 'Detalles de zona',
          },
        ],
      },
      {
        path: 'crane',
        loadComponent: () =>
          import('@gruas/gruas.component').then((c) => c.GruasComponent),
        children: [
          {
            path: 'crane-types',
            loadComponent: () =>
              import('@clase-grua/lista-de-clase-grua/lista-de-clase-grua.component').then(
                (c) => c.ListaDeClaseGruaComponent,
              ),
            title: 'Clases de grúas',
          },
        ],
      },
      {
        path: 'products',
        loadComponent: () =>
          import('@producto/producto.component').then(
            (c) => c.ProductoComponent,
          ),
        children: [
          {
            path: 'list',
            loadComponent: () =>
              import('@producto/lista-de-productos/lista-de-productos.component').then(
                (c) => c.ListaDeProductosComponent,
              ),
            title: 'Lista de productos',
          },
        ],
      },
      {
        path: 'currency',
        loadComponent: () =>
          import('@monedas/monedas.component').then((c) => c.MonedasComponent),
        children: [
          {
            path: 'list',
            loadComponent: () =>
              import('@monedas/lista-de-monedas/lista-de-monedas.component').then(
                (c) => c.ListaDeMonedasComponent,
              ),
            title: 'Lista de monedas',
          },
        ],
      },
      {
        path: 'taxes',
        loadComponent: () =>
          import('@impuestos/impuestos.component').then(
            (c) => c.ImpuestosComponent,
          ),
        children: [
          {
            path: 'list',
            loadComponent: () =>
              import('@impuestos/lista-de-impuestos/lista-de-impuestos.component').then(
                (c) => c.ListaDeImpuestosComponent,
              ),
            title: 'Lista de impuestos',
          },
        ],
      },
      {
        path: 'cars',
        loadComponent: () =>
          import('@catalogo-de-vehiculos/catalogo-de-vehiculos.component').then(
            (c) => c.CatalogoDeVehiculosComponent,
          ),
        children: [
          {
            path: '',
            redirectTo: 'list-clases',
            pathMatch: 'full',
          },
          {
            path: 'list-brand',
            loadComponent: () =>
              import('@catalogo-de-vehiculos/lista-de-marca-vehiculo/lista-de-marca-vehiculo.component').then(
                (c) => c.ListaDeMarcaVehiculoComponent,
              ),
            title: 'Lista de marcas',
          },
          {
            path: 'list-models',
            loadComponent: () =>
              import('@catalogo-de-vehiculos/lista-de-tipo-vehiculo/lista-de-tipo-vehiculo.component').then(
                (c) => c.ListaDeTipoVehiculoComponent,
              ),
            title: 'Lista de tipos de vehículos',
          },
          {
            path: 'list-colors',
            loadComponent: () =>
              import('@catalogo-de-vehiculos/lista-de-colores/lista-de-colores.component').then(
                (c) => c.ListaDeColoresComponent,
              ),
            title: 'Lista de colores',
          },
          {
            path: 'list-clases',
            loadComponent: () =>
              import('@catalogo-de-vehiculos/lista-de-clase-vehiculo/lista-de-clase-vehiculo.component').then(
                (c) => c.ListaDeClaseVehiculoComponent,
              ),
            title: 'Lista de clases de vehículos',
          },
          {
            path: 'form-clase',
            loadComponent: () =>
              import('@catalogo-de-vehiculos/formulario-de-clase-vehiculo/formulario-de-clase-vehiculo.component').then(
                (c) => c.FormularioDeClaseVehiculoComponent,
              ),
            title: 'Formulario de clase de vehículo',
          },
          {
            path: 'edit-clase/:id',
            loadComponent: () =>
              import('@catalogo-de-vehiculos/formulario-de-clase-vehiculo/formulario-de-clase-vehiculo.component').then(
                (c) => c.FormularioDeClaseVehiculoComponent,
              ),
            title: 'Editar clase de vehículo',
          },
        ],
      },
      {
        path: 'knowledge-questions',
        loadComponent: () =>
          import('@preguntas-de-conocimiento/preguntas-de-conocimiento.component').then(
            (c) => c.PreguntasDeConocimientoComponent,
          ),
        children: [
          {
            path: '',
            redirectTo: 'list',
            pathMatch: 'full',
          },
          {
            path: 'list',
            loadComponent: () =>
              import('@preguntas-de-conocimiento/lista-preguntas-de-conocimiento/lista-preguntas-de-conocimiento.component').then(
                (c) => c.ListaPreguntasDeConocimientoComponent,
              ),
            title: 'Preguntas de conocimineto',
          },
          {
            path: 'preview',
            loadComponent: () =>
              import('@preguntas-de-conocimiento/preview-formulario/preview-formulario.component').then(
                (c) => c.PreviewFormularioComponent,
              ),
          },
        ],
      },
      {
        path: 'map',
        loadComponent: () =>
          import('@mapa/map.component').then((c) => c.MapComponent),
        title: 'Mapa de grúas',
      },
    ],
  },
  {
    path: 'token-verification',
    loadComponent: () =>
      import('./features/token-verification/token-verification.component').then(
        (c) => c.TokenVerificationComponent,
      ),
  },
  {
    path: 'recovery',
    title:'Recuperar contraseña',
    loadComponent: () =>
      import('./features/reset-password/reset-password.component').then(
        (c) => c.ResetPasswordComponent,
      ),
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];
